import { useState, useEffect } from "react";

const STORAGE_KEY = "previs-admin-range-days";

/**
 * Range-in-days selector backing state, localStorage-persisted so each page
 * remembers the user's last choice across reloads. Falls back to the
 * supplied default when nothing is stored or the stored value is invalid.
 */
export function useRange(defaultDays: number): [number, (days: number) => void] {
  const [rangeDays, setRangeDaysInternal] = useState<number>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = parseInt(stored, 10);
        if (!isNaN(parsed) && parsed > 0) return parsed;
      }
    } catch { /* localStorage unavailable */ }
    return defaultDays;
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, String(rangeDays)); } catch { /* noop */ }
  }, [rangeDays]);

  return [rangeDays, setRangeDaysInternal];
}
